var map = {
	"./beer_id-1.jpg": "0805",
	"./beer_id-2.jpg": "de8f",
	"./beer_id-3.jpg": "a105",
	"./beer_id-4.jpg": "10e1",
	"./beer_id-5.jpg": "64dc",
	"./beer_id-6.jpg": "82cd",
	"./beer_id-7.jpg": "ec1d",
	"./beer_id-8.jpg": "1e80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2823";